import {Component, EventEmitter, Input, Output} from '@angular/core';
import {ModalService} from "../../../../services/modal.service";

@Component({
  selector: 'app-delete-paylink-dialog',
  templateUrl: './delete-paylink-dialog.component.html',
  styleUrls: ['./delete-paylink-dialog.component.scss']
})
export class DeletePaylinkDialogComponent {
  @Input() selectedPaylink: string[] = []
  @Output() deletePaylinkEvent: EventEmitter<void> = new EventEmitter<void>()

  constructor(
    private modalService: ModalService
  ) {
  }

  closeModal() {
    this.modalService.closeModal()
  }

  deletePaylink() {
    this.deletePaylinkEvent.emit()
  }
}
